import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-history",
  "use": "clock-history-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"clock-history\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 1a6.998 6.998 0 00-6 3.392V1.5c.002-.002 0-.5-.5-.5s-.5.5-.5.5V6h4.5S6 6 6 5.5c0-.467-.438-.495-.494-.5H2.802A6 6 0 112 8H1a7 7 0 107-7zm0 7V4H7v5h4.004l.029-1H8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol